module.exports = __webpack_public_path__ + "img/management-services-img2.119be4c8.png";